export default "__VITE_ASSET__BKfCQEBB__"